import React, { MouseEvent, ReactElement, cloneElement } from 'react'

import { trackClickForSegmentAnalytics } from '@infura/packages.common/segmentAnalytics'

type EventType = 'Button' | 'Text' | 'Image'

type Action = 'click'

interface Event {
  type?: EventType
  text?: string
  href?: string
  location?: string
  imageName?: string
}

interface AnalyticsProps {
  action: Action
  event: Event
  children: ReactElement<any, any>
  onClick?: (e: MouseEvent) => void
  href?: string
}

export const Analytics = React.forwardRef<HTMLElement, AnalyticsProps>(
  ({ action = 'click', children, event, href, onClick, ...props }, ref) => {
    const handleButtonClick = (e: MouseEvent) => {
      const { imageName, location, text, type = 'Button' } = event
      if (onClick) {
        onClick(e)
      }
      trackClickForSegmentAnalytics({
        clickText: text,
        clickUrl: href,
        imageName,
        location,
        type
      })
    }
    return cloneElement(children, {
      ref,
      ...props,
      ...(action === 'click' && { onClick: handleButtonClick })
    })
  }
)
